import React from 'react';
import PropTypes from 'prop-types';
import { withRouter, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import StringConstants from 'app/shared/constants/StringConstants';
import * as RouteConstants from 'app/shared/constants/RouteConstants';
import { AppSelectors, UserSelectors } from 'app/shared/selectors';
import accessUtils from 'app/shared/utils/accessUtils';
import pathsManifest from 'app/shared/pathsManifest';

const PermissionCheck = ({
    route,
    cookieEnabledServices,
    user,
    brand,
    paths,
    location,
    children,
    isRedirectExternal = false,
}) => {
    const checkPermissionsForExternalRedirect = () => {
        let canAccess;
        let redirectTo;

        switch (route) {
            case RouteConstants.SETTINGS_PAGE:
                canAccess = accessUtils.canAccessSettings({ user });

                if (canAccess === false) {
                    redirectTo = pathsManifest.makeAbsolute(paths.userSettingsPage);
                }
                break;

            default:
                // no default;
                break;
        }

        if (canAccess === false) {
            // do redirect
            try {
                // window will not exist when SSR
                return window.router.updateLocation(redirectTo);
            } catch (error) {
                return <Redirect to={redirectTo} />;
            }
        }

        // render children if user can access
        return children;
    };

    if (isRedirectExternal) {
        // return here to prevent page from rendering for a split second (not sure why)
        return checkPermissionsForExternalRedirect();
    }

    const { pathname } = location;
    const redirectTo = {
        [RouteConstants.PDP_PAYMENTS]:
            !user.paymentsAccessAllowed && !cookieEnabledServices.ZG_PAYMENTS_ENABLED &&
                pathname.replace(paths.propertyDetailsPayments, paths.propertyDetailsListing),
        [RouteConstants.PDP_APPLICATIONS]:
            brand !== StringConstants.UNFORMATTED_BRAND_NAMES.zillow &&
                pathname.replace(paths.propertyDetailsApplications, paths.propertyDetailsListing),
        [RouteConstants.BILLING_PAGE]:
            !accessUtils.canAccessBilling({ user, cookieEnabledServices }) && paths.propertiesPage,
        [RouteConstants.USER_MANAGEMENT_PAGE]:
            !accessUtils.canAccessUserManagement({ user, cookieEnabledServices }) && paths.propertiesPage,
        [RouteConstants.ANALYTICS_PAGE]:
            !accessUtils.canAccessGlobalAnalytics({ user, cookieEnabledServices }) && paths.propertiesPage,
        [RouteConstants.CONTACTS_PAGE]:
            !accessUtils.canAccessGlobalContacts({ user, cookieEnabledServices }) && paths.propertiesPage,
        [RouteConstants.INVOICE_PAYMENTS]:
            !accessUtils.canAccessInvoicePayments({ user, cookieEnabledServices }) && paths.propertiesPage,
    };

    return redirectTo[route] ? <Redirect to={redirectTo[route]} /> : children;
};

PermissionCheck.propTypes = {
    route: PropTypes.oneOf(Object.values(RouteConstants)).isRequired,
    user: PropTypes.object.isRequired,
    cookieEnabledServices: PropTypes.object.isRequired,
    paths: PropTypes.object.isRequired,
    brand: PropTypes.string.isRequired,
    location: PropTypes.object.isRequired,
    children: PropTypes.node.isRequired,
};

const mapStateToProps = state => ({
    user: UserSelectors.makeUser(state),
    cookieEnabledServices: AppSelectors.makeCookieEnabledServices(state),
    paths: AppSelectors.makePaths(state),
    brand: AppSelectors.makeBrand(state),
});

export { PermissionCheck };
export default withRouter(connect(mapStateToProps)(PermissionCheck));
